<template>
  <div class="lesson-directions">
    <Mirror @close="toggleMirror" class="mirror" v-if="mirrorVisible" @click="toggleMirror" />
    <div class="video-selector" v-show="!mirrorVisible">
      <div
        v-for="(v, index) in videos"
        class="video-option"
        :class="{'active': index === activeVideoIndex }"
        :key="index"
        @click="setActiveVideo(index)"
      >
        <div class="header">
          <div class="video-title">
            <span v-show="v.type ==='exercise'">{{v.name}}</span>
            <span v-show="v.type ==='phoneme'">発音記号/{{v.name}}/の発音方法</span>
          </div>
          <div style="display:flex; flex-direction: row">
            <div class="tag category">
              <span v-show="v.type ==='exercise'">エクササイズ</span>
              <span v-show="v.type ==='phoneme'">発音記号</span>
            </div>
            <div class="tag playing" v-show="index === activeVideoIndex">選択中</div>
          </div>
        </div>
        <p
          class="video-description"
          v-show="index === activeVideoIndex || videos.length<3"
        >{{v.description}}</p>
      </div>
    </div>

    <div
      class="video-container"
      @mouseenter="videoHovering = true"
      @mouseleave="videoHovering = false"
    >
      <div class="video-type-container">
        <!-- <div class="selected-bar" :class="{'loop-selected': !showDetail}"></div> -->

        <div
          class="type"
          :class="[{'loop': !isPlayingLoop}, {'lecture': isPlayingLoop}]"
          @click="toggleVideoTypeR(activeVideoIndex)"
        >
          <span v-show="isPlayingLoop">
            解説編に切り替え
            <img src="@/assets/class.svg" />
          </span>
          <span v-show="!isPlayingLoop">
            実践編に切り替え
            <img src="@/assets/loop_2.svg" />
          </span>
        </div>
        <!-- <div class="loop" @click="setVideoTypeLoop">実践編</div> -->
      </div>
      <div class="progress-bars-container"></div>
      <video
        v-if="videos[activeVideoIndex]"
        oncontextmenu="return false;"
        ref="video"
        @click="toggle"
      >
        <source
          :src="videos[activeVideoIndex].urls[showDetail ? 'lesson' : 'loop' ]"
          type="video/mp4"
        />
      </video>
      <transition name="fade">
        <div v-show="!playing" class="play-button-overlay" @click="toggle"></div>
      </transition>
      <transition name="zoom-fade">
        <img
          v-show="!playing"
          class="play-button"
          src="@/assets/play.svg"
          alt="Play Button"
          @click="toggle"
        />
      </transition>
      <transition name="slide-fade">
        <div class="control-container" v-show="videoHovering">
          <div
            class="hovering-time"
            v-show="progressHovering"
            :style="`left: ${hoveringPosition}px`"
          >{{floatToMinutes(hoveringPosition / videoWidth * videoInfo.duration)}}</div>
          <div
            class="time"
          >{{floatToMinutes(videoInfo.currentTime)}} / {{floatToMinutes(videoInfo.duration)}}</div>
          <img src="@/assets/fullscreen.svg" class="fullscreen" @click="toggleFullScreen" />

          <div class="volume-control">
            <img v-show="volume === 0" src="@/assets/volume-mute.svg" @click="toggleMute" />
            <img v-show="volume !== 0" src="@/assets/volume-max.svg" @click="toggleMute" />
            <div class="slide-container">
              <el-slider v-model="volume"></el-slider>
            </div>
          </div>
          <div
            @click="setTime"
            @mousemove="showTime"
            class="progress-container"
            @mouseenter="progressHovering = true"
            @mouseleave="progressHovering = false"
          >
            <div class="progress-bg" :class="{'hover-extra-height': progressHovering}"></div>
            <div
              class="progress"
              :style="progressPosition"
              :class="{'hover-extra-height': progressHovering}"
            ></div>
            <div
              class="loaded"
              :style="loadedRange"
              :class="{'hover-extra-height': progressHovering}"
            ></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { db } from "@/main";
import { floatToMinutes } from "@/utils/functions";

let video = null;
export default {
  components: {
    Mirror: require("./Mirror").default,
    Playing: require("@/components/Playing").default
  },

  props: ["videos"],

  data() {
    return {
      mirrorVisible: false,
      videoHovering: false,
      progressHovering: false,
      activeVideoIndex: 0,
      volume: 100,
      savedVolume: 100,
      loading: true,
      videoTypeLecture: false,
      showDetail: true,
      videoWidth: 0,
      isPlayingLoop: false,
      videoInfo: {
        duration: 0,
        currentTime: 0,
        mousePosition: null,
        loaded: [{ start: 0, end: 0 }]
      },
      playing: false,
      hoveringPosition: 0,
      loadedFirstVideo: false
    };
  },
  watch: {
    volume(volume) {
      video.volume = volume * 0.01;
    },
    videoTypeLecture(videoType) {
      this.loading = false;
      if (videoType) {
        video.src = this.videos[this.activeVideoIndex].urls.loop;
        this.videoType = false;
        this.play();
        this.loading = true;
      } else {
        video.src = this.videos[this.activeVideoIndex].urls.lesson;
        this.videoType = true;
        this.play();
        this.loading = true;
      }
    }
  },
  computed: {
    progressPosition() {
      return (
        "width: " +
        (
          (this.videoInfo.currentTime / this.videoInfo.duration) *
          100
        ).toString() +
        "%"
      );
    },
    loadedRange() {
      if (this.videoInfo.loaded.length > 0)
        return (
          "width: " +
          (
            (this.videoInfo.loaded[0].end / this.videoInfo.duration) *
            100
          ).toString() +
          "%"
        );
    }
  },
  methods: {
    toggleMirror() {
      this.mirrorVisible = !this.mirrorVisible;
    },
    toggleFullScreen() {
      video.webkitRequestFullscreen();
    },
    floatToMinutes(time) {
      return floatToMinutes(time);
    },
    toggleMute() {
      const currentVolume = this.volume;
      if (currentVolume !== 0) {
        this.savedVolume = this.volume;
      }
      if (this.volume > 0) {
        this.volume = 0;
      } else {
        this.volume = this.savedVolume;
      }
    },
    initVideo() {
      const firstIndex = 0;
      this.videoTypeLecture = false;
      this.activeVideoIndex = firstIndex;
      video.src = this.videos[firstIndex].urls.lesson;
    },
    setActiveVideo(index) {
      if (index !== this.activeVideoIndex) {
        this.isPlayingLoop = false;
        this.videoTypeLecture = false;
        this.loading = true;
        this.activeVideoIndex = index;
        video.src = this.videos[index].urls.lesson;
        this.play();
      }
    },
    setVideoTypeDetail() {
      video.src = this.videos[this.activeVideoIndex].urls.lesson;
      this.showDetail = true;
      this.play();
      this.loading = true;
    },
    setVideoTypeLoop() {
      video.src = this.videos[this.activeVideoIndex].urls.lesson;
      this.showDetail = false;
      this.play();
      this.loading = true;
    },
    toggleVideoTypeR(index) {
      this.loading = false;
      if (!this.isPlayingLoop) {
        video.src = this.videos[this.activeVideoIndex].urls.loop;
        this.isPlayingLoop = true;
        this.radio = false;
        this.play();
        this.loading = true;
      } else {
        video.src = this.videos[this.activeVideoIndex].urls.lesson;
        this.isPlayingLoop = false;

        this.radio = true;
        this.play();
      }
    },
    showTime(e) {
      this.hoveringPosition = e.offsetX;
    },
    setTime(e) {
      const elapsedPercentage = e.offsetX / 0.95;
      video.currentTime =
        (elapsedPercentage / video.clientWidth) * this.videoInfo.duration;
      if (!this.playing) this.play();
    },
    play() {
      if (this.loadedFirstVideo) {
        video.play();
        this.playing = true;
      }
    },
    toggle() {
      this.playing ? this.pause() : this.play();
    },
    pause() {
      video.pause();
      this.playing = false;
    }
  },
  created() {
    const self = this;
    setTimeout(() => {
      video = this.$refs.video;
      video.addEventListener("loadedmetadata", event => {
        self.loading = false;
        self.videoWidth = event.srcElement.clientWidth;
        var time = video.currentTime;
        var buffered = video.buffered;
        self.videoInfo.duration = video.duration;

        requestAnimationFrame(function update() {
          if (time !== video.currentTime) {
            time = video.currentTime;
            buffered = video.buffered;
            video.dispatchEvent(new CustomEvent("timeupdate"));
          }
          requestAnimationFrame(update);
        });
      });
      video.addEventListener("timeupdate", event => {
        self.videoInfo.currentTime = video.currentTime;
        let loadedRanges = video.buffered;
        let rangesArray = [];
        for (var i = 0; i < loadedRanges.length; i++) {
          rangesArray.push({
            start: loadedRanges.start(i),
            end: loadedRanges.end(i)
          });
        }
        self.videoInfo.loaded = rangesArray;
      });
      self.initVideo();
      self.loadedFirstVideo = true;
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
video {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.custom-video-controls {
  z-index: 2147483647;
}

video::-webkit-media-controls {
  display: none !important;
}
video::-webkit-media-controls-enclosure {
  display: none !important;
}

.lesson-directions {
  /* overflow: hidden; */
  background-color: #fff;

  z-index: 400;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0;
  padding: 0;
  display: block;
  font-size: 0;
  @include mq(sm) {
    height: auto;
    position: relative;
  }
  @include mq(md) {
    height: 337.5px;
    /* position: sticky; */
    top: 0;
  }
  @include mq(lg) {
    height: 393.75px;
  }
  @include mq(xl) {
    height: 450px;
  }

  .mirror {
    z-index: 300;
    float: left;
    cursor: pointer;
    width: 100%;
    height: 430px;
    @include mq(sm) {
      width: 100%;
      height: 430px;
    }
    @include mq(md) {
      width: calc(1000px - 600px);
      height: 337.5px;
    }
    @include mq(lg) {
      width: calc(1200px - 700px);
      height: 393.75px;
    }
    @include mq(xl) {
      width: calc(1300px - 800px);
      height: 450px;
    }
  }

  .video-selector {
    float: left;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;

    @include mq(sm) {
      width: 100%;
      height: 100%;
    }
    @include mq(md) {
      width: calc(1000px - 600px);
    }
    @include mq(lg) {
      width: calc(1200px - 700px);
    }
    @include mq(xl) {
      width: calc(1300px - 800px);
    }
    .active {
      padding: 10px 0;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
      .header {
        .video-title {
          color: $main-color;
          font-size: 1rem;
        }
        p {
          font-size: 1rem;
        }
      }
    }
    .video-option {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .tag {
          font-size: 12px;
          font-weight: bold;
          padding: 2px 8px;
          border-radius: 4px;
          margin-left: 5px;
        }
        .playing {
          color: white;
          background-color: $main-color;
        }
        .category {
          color: white;
          background-color: #ccc;
        }
      }
      cursor: pointer;
      display: flex;
      transition: all 0.3s ease;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      box-sizing: border-box;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
      padding: 10px;
      box-sizing: border-box;
      padding: 5px 15px;
      .header {
        .video-title {
          font-size: 1.13rem;
          font-weight: bold;
        }
      }
      p {
        font-size: 0.8rem;
      }
      @include mq(sm) {
        .header {
          .video-title {
            font-size: 1.3rem;
            font-weight: bold;
          }
        }
        p {
          font-size: 0.8rem;
        }
      }
      @include mq(md) {
        box-sizing: border-box;
        padding: 5px 10px;
        .header {
          .video-title {
            font-size: 1.13rem;
            font-weight: bold;
          }
        }
        p {
          font-size: 0.8rem;
        }
      }
      @include mq(lg) {
        padding: 10px;
        .video-title {
          font-size: 1.3rem;
          font-weight: bold;
          padding: 4px 0;
        }
        p {
          font-size: 0.9rem;
          margin: 0;
        }
      }
      p {
        margin-top: 3px;
        font-family: "Meiryo", "Noto Sans Japanese", sans-serif;
      }
      &:last-child {
        border: none;
      }
    }
  }
  .video-container {
    display: inline-block;
    position: relative;
    height: 100%;
    overflow: hidden;
    z-index: 400;

    @include mq(sm) {
      width: 100%;
    }
    @include mq(md) {
      width: 600px;
    }
    @include mq(lg) {
      width: 700px;
    }
    @include mq(xl) {
      width: 800px;
    }

    .play-button-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
    }

    .play-button {
      user-select: none;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      width: 20%;
    }
  }
}

.hover-extra-height {
  position: absolute;
  transform: scaleY(1.5);
  transform-origin: center;
}

.control-container {
  .hovering-time {
    position: absolute;
    /* transform: translateX(-50%); */
    background-color: rgba(0, 0, 0, 0.2);
    padding: 1px 5px;
    font-size: 0.8rem;
    border-radius: 4px;
    color: white;
    top: -20px;
  }
  .time {
    position: absolute;
    left: 160px;
    top: 24px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.8rem;
  }
  .progress-container {
    position: relative;
    transition: all 0.1s;
    cursor: pointer;
    padding: 10px 0;
  }

  .fullscreen {
    cursor: pointer;
    position: absolute;
    top: 28px;
    right: 2.5%;
    width: 17px;
  }
  .volume-control {
    position: absolute;
    top: 25px;
    width: 120px;
    img {
      cursor: pointer;
      width: 17px;
    }
    .slide-container {
      position: absolute;
      top: -10px;
      left: 26px;
      width: 100px;
      transform: scale(0.8);
    }
  }
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgb(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
  position: absolute;
  right: 0;
  margin: 0 auto;
  left: 0;
  padding: 0 2.5%;
  height: 55px;
  z-index: 0;
  bottom: 0;
  .progress-bg {
    position: absolute;
    z-index: 100;
    height: 3px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    transition: transform 0.15s ease;
  }
  .progress {
    position: absolute;
    z-index: 101;
    height: 3px;
    width: 100%;
    background: $main-color;
    opacity: 0.95;
    transition: transform 0.15s ease;
  }
  .loaded {
    position: absolute;
    z-index: 100;
    height: 3px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.15);
    transition: transform 0.15s ease;
  }
}

.video-type-container {
  font-size: 0.8rem;
  cursor: pointer;
  z-index: 204;
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  /* .selected-bar {
    transition: transform 0.4s ease;
    transform: translateX(0);
    padding: 0;
    width: 50%;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.9);
    height: 3px;
    position: absolute;
  } */
  .loop-selected {
    transform: translateX(100%);
  }
  div {
    @include flex-centerer-column;
    padding: 4px 10px;
    color: white;
    img {
      padding-top: 3px;
      width: 14px;
    }
  }

  .type {
    display: inline-block;
    position: relative;
    padding: 4px 24px 4px 10px;
    border-radius: 40px;
    img {
      position: absolute;
      width: 15px;
      right: 7px;
      top: 3px;
    }
  }
  .lecture {
    background-color: $main-color;
    &:hover {
      background-color: #f77;
    }
  }
  .loop {
    background-color: #555;
    &:hover {
      background-color: #444;
    }
  }
}

// animations
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

// overlay fade

.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// play icon

.zoom-fade-enter-active {
  transition: all 0.3s ease;
}
.zoom-fade-leave-active {
  transition: all 0.3s ease;
}
.zoom-fade-enter,
.zoom-fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>
